import { useEffect, useState } from 'react';

/**
 * useDarkMode
 * ───────────
 * Gère le thème sombre de l'admin.
 * Persiste le choix dans localStorage sous la clé "admin-theme".
 * Applique/retire data-theme="dark" sur <body>.
 */
const useDarkMode = () => {
  const [dark, setDark] = useState(() => {
    return localStorage.getItem('admin-theme') === 'dark';
  });

  useEffect(() => {
    if (dark) {
      document.body.setAttribute('data-theme', 'dark');
      localStorage.setItem('admin-theme', 'dark');
    } else {
      document.body.removeAttribute('data-theme');
      localStorage.setItem('admin-theme', 'light');
    }
  }, [dark]);

  const toggle = () => setDark(d => !d);

  return { dark, toggle };
};

export default useDarkMode;